import React, { useEffect, useState } from "react";
import {
    Modal,
    Fade,
    Grid,
    Typography,
} from "@material-ui/core";
import usePackageUpdateModalStyles from "./usePackageUpdateModalStyles";
import Utils from "../../helpers/Utils";
import PackageUpdateCaution from "./PackageUpdateCaution";
import { getPackagesList } from "../../api/profileApi";
import { useDispatch, useSelector } from "react-redux";
import { fetchDetails } from "../../actions/billingAction";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import PlanItem from "./PlanItem";
import PackageItemSkeleton from "../packagesCommonComponents/PackageItemSkeleton";

const PRICING_MONTHLY = 'MONTHLY';
const PRICING_YEARLY = 'YEARLY';
const PRICING_CUSTOM = 'CUSTOM';

const PRICING_TYPE_MONTHLY = 'monthly';
const PRICING_TYPE_YEARLY = 'yearly';
const PRICING_TYPE_CUSTOM = 'custom';


const PRICING_ID_PRICING_TYPE_MAPPING = {
    1: PRICING_TYPE_MONTHLY,
    2: PRICING_TYPE_YEARLY,
    3: PRICING_TYPE_CUSTOM
};

const PACKAGE_TYPE_PAID = 'PAID';

const TrialPackageUpdateModal = ({ isOpen = false, onClose }) => {
    const dispatch = useDispatch();
    const { userPackage } = useSelector((state) => (state.billingReducer));
    const [showCautionAlert, setShowCautionAlert] = useState(false);
    const [plans, setPlans] = useState([]);
    const [customPlans, setCustomPlans] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [priceType, setPriceType] = useState('yearly');

    useEffect(() => {
        loadPlans();
    }, []);

    useEffect(()=>{
        autoSelectPriceType();
    },[userPackage]);

    const autoSelectPriceType = () => {
        try{
            if (userPackage && userPackage?.package?.package_type === PACKAGE_TYPE_PAID && PRICING_ID_PRICING_TYPE_MAPPING[userPackage.pricing_id]){
                setPriceType(PRICING_ID_PRICING_TYPE_MAPPING[userPackage.pricing_id]);
            }
        }catch (err){
            console.log(err);
        }
    };

    const loadPlans = async () => {
        try {
            setLoading(true);
            const response = await getPackagesList({});

            if (response?.data?.data) {
                setPlans(response.data.data.packages);

                if (response.data.data?.customPlan) {
                    setCustomPlans(response.data.data.customPlan);
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const filteredPlans = () => {
        try {
            const filteredPlans = [];

            plans.forEach(plan => {
                const pricing = JSON.parse(plan.pricing);
                const view_features = JSON.parse(plan.view_features);

                pricing.forEach(price => {
                    const current_plan = userPackage?.package?.id === plan.id && userPackage?.pricing_id === price.id;
                    const description = (plan.max_sub_user === null && plan.price_for_subuser === 0) ? 'Unlimited Users' : (plan.max_sub_user > 0 ? `Up to ${plan.max_sub_user + 1} Users` : 'Ideal for Individual Use');

                    if (priceType === PRICING_TYPE_MONTHLY && price.name === PRICING_MONTHLY && price.price !== null) {
                        filteredPlans.push({
                            plan_id: plan.id,
                            title: plan.name,
                            features: view_features,
                            price_id: price.id,
                            price: price.price,
                            stripe_price_id: price.stripe_price_id,
                            validity: price.validity,
                            description: description,
                            custom: false,
                            current_plan: current_plan,
                        });
                    } else if (priceType === PRICING_TYPE_YEARLY && price.name === PRICING_YEARLY && price.price !== null) {
                        filteredPlans.push({
                            plan_id: plan.id,
                            title: plan.name,
                            features: view_features,
                            price_id: price.id,
                            price: price.price,
                            stripe_price_id: price.stripe_price_id,
                            validity: price.validity,
                            description: description,
                            custom: false,
                            current_plan: current_plan,
                        });
                    } else if (priceType === PRICING_TYPE_CUSTOM && price.name === PRICING_CUSTOM && price.price !== null) {
                        filteredPlans.push({
                            plan_id: plan.id,
                            title: plan.name,
                            features: view_features,
                            price_id: price.id,
                            price: price.price,
                            stripe_price_id: price.stripe_price_id,
                            validity: price.validity,
                            description: description,
                            custom: false,
                            current_plan: current_plan,
                            price_type: price.name
                        });
                    }
                });
            });

            if (customPlans) {
                customPlans.forEach(plan => {
                    const pricing = JSON.parse(plan.pricing);
                    const view_features = JSON.parse(plan.view_features);
                    pricing.forEach(price => {
                        const current_plan = userPackage?.package?.id === plan.id && userPackage?.pricing_id === price.id;
                        const description = (plan.max_sub_user === null && plan.price_for_subuser === 0) ? 'Unlimited Users' : (plan.max_sub_user > 0 ? `Up to ${plan.max_sub_user + 1} Users` : 'Ideal for Individual Use');

                        if (priceType === PRICING_TYPE_MONTHLY && price.name === PRICING_MONTHLY && price.price !== null) {
                            filteredPlans.push({
                                plan_id: plan.id,
                                title: plan.name,
                                features: view_features,
                                price_id: price.id,
                                price: price.price,
                                stripe_price_id: price.stripe_price_id,
                                validity: price.validity,
                                description: description,
                                custom: true,
                                current_plan: current_plan,
                            });
                        } else if (priceType === PRICING_TYPE_YEARLY && price.name === PRICING_YEARLY && price.price !== null) {
                            filteredPlans.push({
                                plan_id: plan.id,
                                title: plan.name,
                                features: view_features,
                                price_id: price.id,
                                price: price.price,
                                stripe_price_id: price.stripe_price_id,
                                validity: price.validity,
                                description: description,
                                custom: true,
                                current_plan: current_plan,
                            });
                        } else if (priceType === PRICING_TYPE_CUSTOM && price.name === PRICING_CUSTOM && price.price !== null) {
                            filteredPlans.push({
                                plan_id: plan.id,
                                title: plan.name,
                                features: view_features,
                                price_id: price.id,
                                price: price.price,
                                stripe_price_id: price.stripe_price_id,
                                validity: price.validity,
                                description: description,
                                custom: true,
                                current_plan: current_plan,
                                price_type: price.name
                            });
                        }
                    });
                });
            }

            return filteredPlans;
        } catch (err) {
            console.log(err);
            return [];
        }
    };

    const hasCustomPricing = (planList) => {
        try {
            return planList.some(plan => {
                const pricing = JSON.parse(plan.pricing);
                return pricing.some(price =>
                    price.name === PRICING_CUSTOM &&
                    price.price !== null
                );
            });
        }catch (err){
            return false;
        }
    };

    const hasCustom = hasCustomPricing(plans) || hasCustomPricing(customPlans);

    const handleToggle = (type) => {
        setPriceType(type);
    };

    const classes = usePackageUpdateModalStyles({
        hasCustom: hasCustom
    });

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            className={classes.modal}
        >
            <Fade in={isOpen}>
                <div className={classes.paper}>
                    <div className={classes.header}>
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className={classes.companyLogo}>
                        <img
                            src={Utils.getAccountData('agencyLogo')}
                            alt={Utils.getAccountData('AuthUserAgencyName')}
                        />
                    </div>

                    <div className={classes.toggleContainer}>
                        <Typography
                            className={`${classes.toggleOption} ${priceType === 'monthly' ? 'active' : ''}`}
                            onClick={() => { handleToggle('monthly'); }}
                            style={{ height: 'unset !important' }}
                        >
                            Monthly
                        </Typography>
                        <Typography
                            className={`${classes.toggleOption} ${priceType === 'yearly' ? 'active' : ''}`}
                            onClick={() => { handleToggle('yearly'); }}
                            style={{ height: 'unset !important' }}
                        >
                            Annual
                        </Typography>

                        {
                            hasCustom &&
                            <Typography
                                className={`${classes.toggleOption} ${priceType === 'custom' ? 'active' : ''}`}
                                onClick={() => { handleToggle('custom'); }}
                                style={{ height: 'unset !important' }}
                            >
                                Custom
                            </Typography>
                        }
                        <div className={`${classes.toggleSlider} ${priceType}`} />
                    </div>

                    <div className={classes.selectPlanContainer}>
                        <Typography variant={'h5'} className={classes.selectPlanText}>
                            Select Your Plan:
                        </Typography>
                    </div>

                    <div className={classes.gridContainer}>
                        {
                            loading ?
                                Array(5)
                                    .fill(1)
                                    .map((_, index) => (
                                        <PackageItemSkeleton key={index} />
                                    )) :
                                <Grid container spacing={3} wrap="nowrap" className={classes.cardContainer}>
                                    {filteredPlans()
                                        .map((plan, index) => (
                                            <PlanItem
                                                plan={plan}
                                                key={index}
                                                setSelectedPlan={setSelectedPlan}
                                                setShowCautionAlert={setShowCautionAlert}
                                            />
                                        ))}
                                </Grid>
                        }
                    </div>

                    {
                        showCautionAlert &&
                        <PackageUpdateCaution
                            isOpen={showCautionAlert}
                            selectedPlan={selectedPlan}
                            onClose={() => { setShowCautionAlert(false); }}
                            onCloseUpdatePlanModal={() => {
                                dispatch(fetchDetails());
                                onClose();
                            }}
                        />
                    }
                </div>
            </Fade>
        </Modal>
    );
};

export default TrialPackageUpdateModal;